export class AtlasUtils {
    //-------------------------------------------------------------------------
    /**
     * Vytvori atlas z textury, ktera obsahuje jednotlive snimky v mrizce
     * @param texture Textura se snimky
     * @param framesPerRow Pocet snimku na radce
     * @param framesPerCol Pocet snimku ve sloupci
     * @param frameNameBase Zaklad pro jmeno snimku. K zakladu se prida index snimku. Indexuje se od 0
     * @param totalFrameCnt Celkovy pocet snimku. Pokud nezadano nebo <= 0, tak pocet snimku je roven framesPerRow * framesPerCol
     * @param pivot Pivot pro snimky (v pomeru 0 az 1)
     * @returns 
     */
    //-------------------------------------------------------------------------
    static createAtlas(texture: pc.Texture, framesPerRow: number, framesPerCol: number, frameNameBase: string, totalFrameCnt?: number, pivot: pc.Vec2 = new pc.Vec2(0.5, 0.5)): pc.TextureAtlas {
        let atlas = new pc.TextureAtlas();

        atlas.texture = texture;

        if (totalFrameCnt == undefined || totalFrameCnt <= 0)
            totalFrameCnt = framesPerRow * framesPerRow;

        let frameW = texture.width / framesPerRow;
        let frameH = texture.height / framesPerCol;
        let frameId = 0;
        let border = new pc.Vec4(0, 0, 0, 0);

        for (let rowId = 0; rowId < framesPerCol; rowId++) {
            for (let colId = 0; colId < framesPerRow && frameId < totalFrameCnt; colId++) {
                atlas.setFrame(frameNameBase + frameId++, {
                    rect: new pc.Vec4(colId * frameW, rowId * frameH, frameW, frameH),
                    pivot: pivot,
                    border: border
                });
            }
        }

        return atlas;
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci region daneho framu v atlasu (U, V, W, H)
     * @param atlas 
     * @param frame 
     * @param out
     * @returns Pokud frame v atlasu neexistuje, tak vraci undefined
     */
    //-------------------------------------------------------------------------
    static getAtlasFrameRegion(atlas: pc.TextureAtlas, frameKey: string, out?: pc.Vec4): pc.Vec4 {
        // Ziskat snimek
        let frame = atlas.frames[frameKey] as pc.TextureAtlasFrame;

        if (!frame)
            return undefined;

        // Prepocitat
        return AtlasUtils.getTexFrameRegion(atlas.texture, frame.rect, out);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci region daneho frame v texture (U, V, W, H)
     * @param texture 
     * @param frameRect 
     * @param out 
     */
    //-------------------------------------------------------------------------
    static getTexFrameRegion(texture: pc.Texture, frameX: number | pc.Vec4, out?: pc.Vec4, frameY?: number, frameW?: number, frameH?: number): pc.Vec4 {
        let texW = texture.width;
        let texH = texture.height;

        if (!out)
            out = new pc.Vec4();

        if (frameX instanceof pc.Vec4) {
            frameY = frameX.y;
            frameW = frameX.z;
            frameH = frameX.w;
            frameX = frameX.x;
        }

        out.x = frameX / texW;
        out.y = frameY / texH;
        out.z = frameW / texW;
        out.w = frameH / texH;

        return out;
    }
}



export class TextureAtlasFramePlaneData {
    private _frameSize: pc.Vec2;
    private _framePivot: pc.Vec2;

    get vertexOffsets(): pc.Vec4 { return this._vertexOffsets; }
    private _vertexOffsets: pc.Vec4;

    get vertexUVs(): pc.Vec4 { return this._vertexUVs; }
    private _vertexUVs: pc.Vec4;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(atlas: pc.TextureAtlas, frameKey: string, pixelsPerUnit: number) {
        let frame = atlas.frames[frameKey] as pc.TextureAtlasFrame;
        let frameRc = frame.rect;

        this._frameSize = new pc.Vec2(frameRc.z / pixelsPerUnit, frameRc.w / pixelsPerUnit);
        this._framePivot = frame.pivot;
        this._vertexUVs = AtlasUtils.getTexFrameRegion(atlas.texture, frameRc, new pc.Vec4());

        this._vertexOffsets = new pc.Vec4(-this._frameSize.x * this._framePivot.x, -this._frameSize.y * this._framePivot.y, this._frameSize.x * (1 - this._framePivot.x), this._frameSize.y * (1 - this._framePivot.y))
    }
}